import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { ApiService } from 'src/core/api/api.service';
import { Country, ICity, IDepartments, SelectorPhoneCountry } from 'src/ui/interfaces/selector-country.interfaces';
import { PhoneValidationService } from 'src/core/services/phone-validation/phone-validation.service';

export type CountryWithFlag = Country & { flagUrl: string };

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private useMock = false;

  constructor(
    private api: ApiService,
    private phoneValidationService: PhoneValidationService
  ) {}

  getDepartamentsById(countryId: number) {
    return this.api.get<IDepartments[]>(`country/${countryId}/departments`)
      .pipe(retry(1));
  }

  getCitiesById(departmentID: number) {
    return this.api.get<ICity[]>(`country/departments/${departmentID}/cities`)
      .pipe(retry(1));
  }

  getCountriesAll(): Observable<CountryWithFlag[]> {
    return this.api.get<any[]>('country').pipe(
      map((countries: any[] = []) => {
        if (!Array.isArray(countries)) {
          return [] as CountryWithFlag[];
        }
        
        console.log('Countries fetched:', countries);

        let filtered = countries.filter((c) => c.is_latam === true);
        if (filtered.length === 0) {
          filtered = countries;
        }

        return filtered.map(
          (c) =>
            ({
              id: c.id,
              name: c.name,
              isoCode: c.iso_code,
              dialCode: c.dial_code,
              flagUrl: `https://flagcdn.com/w80/${String(c.iso_code).toLowerCase()}.webp`,
            } as CountryWithFlag),
        );
      }),
      catchError(() => of([] as CountryWithFlag[])),
    );
  }

  getCountries(): Observable<SelectorPhoneCountry[]> {
    return this.phoneValidationService.getAllPhoneRules().pipe(
      map(countries => countries.map(c => ({
        ...c,
        flagUrl: `https://flagcdn.com/w80/${c.isoCode.toLowerCase()}.webp`
      })))
    );
  }
}
